export default __webpack_public_path__ + "static/media/Jason-Orien.bc93dcdb.png";